import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6558af52")

_pushScopeId("data-v-6558af52")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "title is-2 has-text-centered" }, "Shopping Cart", -1)
const _hoisted_3 = {
  key: 0,
  class: "errors",
  id: "notification-errors"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Place order errors:", -1)
const _hoisted_5 = {
  key: 1,
  class: "basket",
  id: "basket"
}
const _hoisted_6 = { class: "columns is-multiline" }
const _hoisted_7 = { class: "column is-6" }
const _hoisted_8 = { class: "columns is-multiline" }
const _hoisted_9 = { class: "column thumbnail-cont" }
const _hoisted_10 = { class: "column" }
const _hoisted_11 = { class: "item-details" }
const _hoisted_12 = { class: "title is-4" }
const _hoisted_13 = { class: "subtitle is-6" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Quantity", -1)
const _hoisted_16 = { class: "control" }
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "buttons" }
const _hoisted_19 = { class: "column details-side" }
const _hoisted_20 = { class: "box has-background-light" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { class: "label" }, "PO Number", -1)
const _hoisted_23 = { class: "control" }
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Delivery Method", -1)
const _hoisted_26 = { class: "control" }
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { class: "label" }, "External Order ID", -1)
const _hoisted_29 = { class: "control" }
const _hoisted_30 = { class: "continue buttons" }
const _hoisted_31 = {
  key: 2,
  class: "has-text-centered"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "has-text-danger" }, " No items in the shopping cart. Redirecting to product page... ", -1)
const _hoisted_33 = {
  key: 3,
  class: "hidden",
  id: "details"
}
const _hoisted_34 = { class: "columns details" }
const _hoisted_35 = { class: "column" }
const _hoisted_36 = /*#__PURE__*/_createVNode("h1", { class: "title is-2 has-text-centered" }, "Billing address", -1)
const _hoisted_37 = { class: "column" }
const _hoisted_38 = /*#__PURE__*/_createVNode("h1", { class: "title is-2 has-text-centered" }, "Shipping address", -1)
const _hoisted_39 = { class: "columns bottom-buttons" }
const _hoisted_40 = { class: "column is-12" }
const _hoisted_41 = { class: "buttons is-centered mt-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Address = _resolveComponent("Address")
  const _component_InfigoLoading = _resolveComponent("InfigoLoading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.placeOrderIssues.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.placeOrderIssues, (issue, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "notification is-danger"
              }, _toDisplayString(issue), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.cartItems.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cartItems, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "box has-background-light"
                  }, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _createVNode("img", {
                          src: _ctx.getThumbUrl(item.thumbnailUrls[0]),
                          alt: "Thumbnail",
                          class: "thumbnail"
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("h2", _hoisted_12, _toDisplayString(item.productName), 1),
                          _createVNode("p", _hoisted_13, _toDisplayString(item.productSKU), 1),
                          _createVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createVNode("div", _hoisted_16, [
                              _withDirectives(_createVNode("input", {
                                type: "number",
                                onInput: ($event: any) => (_ctx.onQuantityChange(index, $event)),
                                "onUpdate:modelValue": ($event: any) => (item.quantity = $event),
                                min: "1",
                                class: "input"
                              }, null, 40, ["onInput", "onUpdate:modelValue"]), [
                                [
                                  _vModelText,
                                  item.quantity,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_17, [
                            _createVNode("div", _hoisted_18, [
                              (_ctx.canEditJob(index))
                                ? (_openBlock(), _createBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.editItem(index)),
                                    class: "button is-info is-small"
                                  }, " Edit ", 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.canEditOptions(index))
                                ? (_openBlock(), _createBlock("button", {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.editOptions(index)),
                                    class: "button is-info is-small"
                                  }, " Edit Options ", 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.canCreateOutput(index))
                                ? (_openBlock(), _createBlock("button", {
                                    key: 2,
                                    onClick: ($event: any) => (_ctx.getOutput(index)),
                                    class: "button is-info is-small"
                                  }, " Create Output ", 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode("button", {
                                onClick: ($event: any) => (_ctx.removeItem(index)),
                                class: "button is-danger is-small"
                              }, " Remove ", 8, ["onClick"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode("div", _hoisted_23, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.poNumber = $event)),
                        class: "input",
                        placeholder: "Enter PO Number"
                      }, null, 512), [
                        [_vModelText, _ctx.poNumber]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode("div", _hoisted_26, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.deliveryMethod = $event)),
                        class: "input"
                      }, null, 512), [
                        [_vModelText, _ctx.deliveryMethod]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.externalOrderId = $event)),
                        class: "input",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, _ctx.externalOrderId]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _createVNode("button", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearCart && _ctx.clearCart(...args))),
                      class: "button is-warning",
                      disabled: _ctx.loading
                    }, " Clear All Items ", 8, ["disabled"]),
                    _createVNode("button", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.continueCart && _ctx.continueCart(...args))),
                      class: "button is-success",
                      disabled: _ctx.loading
                    }, " Continue Order ", 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_31, [
            _hoisted_32
          ])),
      (_ctx.cartItems.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_33, [
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_Address, {
                  address: _ctx.billingAddress,
                  onAddressChange: _ctx.onBillingAddressChange
                }, null, 8, ["address", "onAddressChange"])
              ]),
              _createVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_Address, {
                  address: _ctx.shippingAddress,
                  onAddressChange: _ctx.onShippingAddressChange
                }, null, 8, ["address", "onAddressChange"])
              ])
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _createVNode("button", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.continueCart && _ctx.continueCart(...args))),
                    class: "button is-success",
                    disabled: _ctx.loading
                  }, " Back ", 8, ["disabled"]),
                  _createVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.placeOrder && _ctx.placeOrder(...args))),
                    class: "button is-success",
                    disabled: _ctx.loading
                  }, " Place Order ", 8, ["disabled"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_InfigoLoading, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
})